import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/locations',
        component: () => import('@/pages/locations/LocationsIndex.vue'),
        props: true,
        meta: {
            title: 'Locations',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'locations' },
        },
        children: [
            {
                path: '',
                name: 'locations-index',
                component: () => import('@/components/locations/LocationsView.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'locations' },
                },
                props: true,
            },
        ],
    },

    {
        path: '/locations/create',
        name: 'location-create',
        component: () => import('@/pages/locations/LocationCreate.vue'),
        props: true,
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'create', subject: 'location' },
        },
    },

    {
        path: '/locations/:locationId',
        name: 'location-view',
        component: () => import('@/pages/locations/LocationView.vue'),
        props: true,
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'location' },
        },
    },

    {
        path: '/locations/:locationId/edit',
        name: 'location-edit',
        component: () => import('@/pages/locations/LocationEdit.vue'),
        props: true,
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'edit', subject: 'location' },
        },
    },
];
